import React, {PropTypes} from 'react';
import ScreenHeader from '../Subcomponents/ScreenHeader';
import ScreenInstructions from '../Subcomponents/ScreenInstructions';
import ScreenContainer from '../Subcomponents/ScreenContainer';

class Success extends React.Component {
    constructor(props) {
        super(props);
    }

       render() {
        let textResources = this.props.textResources;
        let values = this.props.values;
        return (
                <ScreenContainer>
                    <ScreenHeader title={textResources.HeaderTitle} text={textResources.HeaderText} icon="tick-in-circle.png" iconIsCircle="true"/>
                    <ScreenInstructions title={textResources.InstructionTitle} text={textResources.InstructionText}/>

                    <div className="o-pageSection o-pageSection--form">
                        <div className="pf-button-container">
                        <a className="c-Btn c-Btn--primary u-mb6" href={values.ContinueUrl}>{textResources.ContinueButtonText}</a>
                        </div>
                    </div>
                </ScreenContainer>
            );
        }
}



Success.propTypes = {
    name: React.PropTypes.string.isRequired,
    values: React.PropTypes.object.isRequired,
    uiSpec: React.PropTypes.object.isRequired,
    textResources: React.PropTypes.object.isRequired
};


export default Success;


/** WEBPACK FOOTER **
 ** ./src/components/ScreenComponents/Shared/Success.js
 **/